import { HexColor } from '@moojo/domain-types'
import { z } from 'zod'

/**
 * Contains all the visual and textual content required to render an ad in HTML.
 * Separated from the Ad entity to focus purely on presentation/rendering needs.
 */
export const AdContent = z.object({
  headline: z.string(),
  subHeadline: z.string(),
  imageUrl: z.string().url().optional(),
  callToActionText: z.string(),
  primaryColor: HexColor,
  secondaryColor: HexColor,
})

export type AdContent = z.infer<typeof AdContent>
